import {Layout} from '../components/Layout/Layout';
import styles from './events.module.scss';
import {clsIf, clss} from "../src/utils";
import {ReactElement, useEffect, useState} from "react";
import {ActionButton} from "../components/ActionButton/ActionButton";
import postWorkation from "../public/images/posts/workation2.jpg";
import postWork from "../public/images/posts/work2.jpg";
import * as gtag from "../src/gtag";
import {PostsPageContent} from "../components/PostsLayout/PostsPageContent";
import {sendFormData} from "../src/forms";

type PostData = {
  name: string,
  date: string,
  title: string,
  description: string | ReactElement,
  buttonText: string,
  submitFormMessage: string,
  image: any,
  drawingPriority?: boolean,
}

export default function Events() {

  let posts: PostData[] = [{
    name: 'work',
    date: 'All year long!',
    title: 'Barbaros Hut – Work',
    description: <>Do you work remotely and travel? Then Barbaros Hut is created for you 🙌 This house in Peniche, Portugal is 100% nomad friendly: enjoy the <b>equipped work zone</b>, meet other <b>digital nomads and remote workers</b>, learn to <b>surf</b>, and get to a <b>new level of work-life balance</b> by the ocean!</>,
    buttonText: 'Book now',
    submitFormMessage: 'Workation Summer 22',
    image: postWork,
    drawingPriority: true,
  }, {
    name: 'workation_oct',
    date: 'October 9–23, 2022',
    title: 'Barbaros Hut – Workation',
    description: <>Escape the autumn gloom and spend two weeks by the ocean in Peniche, Portugal 🇵🇹 A whole <b>all-inclusive camp for digital nomads</b> in Barbaros Hut: equipped work zone, hiking tours, yoga, surfing classes, movie nights, breakfast, and more! Travel while working, network while chilling. Sounds interesting? Leave your email below, and we’ll contact you with more detail ASAP 🏄</>,
    buttonText: 'Book now',
    submitFormMessage: 'Work Autumn 22',
    image: postWorkation,
  }];


  return (
    <Layout title={"Events For Digital Nomads | Digital Barbaros"} description={"Looking for ways to connect with other digital nomads in your area? We host events for strong work-life balances. Learn how you can become part of our community"} subUrl={'events'}>
      {/*<div className={styles.screenHeader}>
        <div className={styles.backgroundContainer}>
          <Image src={bckMedia} priority={true} draggable={false} alt={""}
                 layout={"responsive"} objectFit={"cover"}/>
        </div>
        <h2><b>Events</b></h2>
      </div>
      {posts.map(post => <EventPost key={post.title} largePost={post}/>)}*/}

      <PostsPageContent
        title={"Events For Digital Nomads"}
        posts={posts}
        withMask={true}
        control={(largePost) => {
          let [email, setEmail] = useState('');
          const [emailHasError, setEmailHasError] = useState(false);
          const [formSubmitted, setFormSubmitted] = useState(false);
          const [sending, setSending] = useState(false);
          const [error, setError] = useState(false);
          const [submitEnabled, setSubmitEnabled] = useState(false);

          useEffect(() => {
            setSubmitEnabled(emailReg.test(email))
          }, [email])

          async function submitForm(submitFormMessage: string) {
            if (!emailReg.test(email)) {
              setEmailHasError(true);
              return;
            }
            setFormSubmitted(true)
            setSending(true);
            try {
              await sendFormData(email, 'events_inline', submitFormMessage)
            } catch (e: any) {
              setError(true)
            }
            setSending(false)
          }

          return formSubmitted ?
              sending ? <div className={styles.infoPlate}>...</div> : error ? <div className={clss(styles.infoPlate, styles.error)}>Woops... Something went wrong. Please try again later, or write directly to <a href="mailto:welcome@satelstories.com">welcome@satelstories.com</a></div> :
                <div className={styles.infoPlate}>Ahoy! Thanks for reaching out, we’ll answer you as soon as possible</div>
              :
              <>
                <input className={clss(styles.input, clsIf(emailHasError, styles.error))} placeholder={'my-email@example.com'} value={email} onChange={(e) => {setEmail(e.target.value); setEmailHasError(false)}}/>
                <ActionButton label={largePost.buttonText} size={'input'}
                              onClick={() => {
                                gtag.event({
                                  action: "submit_form",
                                  label: "events",
                                  label2: largePost.name,
                                });

                                submitForm(largePost.submitFormMessage)
                              }}/>
              </>
        }}
      />
    </Layout>
  )
}

const emailReg = /^([A-Za-z0-9_\-\.+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
